<div class="container-detail-hotel">
  <ng-container *ngIf="hotelDetailSearched$ | async">
    <div class="cont-gallery">
      <app-image-gallery-mobile
        *ngIf="true"
        [images]="(hotelDetailSearched$ | async)?.Images"
        [isEmulateRoute]="showInHotelResult">
      </app-image-gallery-mobile>
      <div class="description-hotel">
        <app-hotel-detail-header
          [hotel]="(hotelDetailSearched$ | async)"
          [externalClass]="'hotel-description-mobile'"
          [isInternational]="isInternational$ | async"
          [isLoggedIn]="isLoggedIn"
          [showDetailHotel]="true"
          [isMobile]="true">
        </app-hotel-detail-header>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="(isLoadingHotelDetail$ | async) === false; else detailPlaceholder">
    <ng-container *ngIf="(hasHotelDetailSearched$ | async) === false">
      <div class="cont-gallery">
        <app-image-gallery-mobile
          [images]="(hotelDetail$ | async)?.Info?.Images || []"
          [isEmulateRoute]="showInHotelResult">
        </app-image-gallery-mobile>
      </div>
    </ng-container>

    <div class="content-hotel">
      <app-hotel-description-mobile
        [hotel]="hotelDetail$ | async"
        [params]="hotelDetailParams"
        [hotelAmenities]="hotelAmmenities"
        [stars]="hotelDetail$ | async | stars"
        [headerSticky]="headerSticky"
        [isLoggedIn]="isLoggedIn"
        [isPackageHotel]="isPackageDetail$ | async"
        [showHotelName]="(hasHotelDetailSearched$ | async) === false"
        [resetBoxTitlesPosition]="resetBoxTitlesPosition"
        [isInternational]="isInternational$ | async"
        (openMap)="toggleMap()"
        (toggleAmenities)="toggleAmenities.emit()"
        (goToGallery)="openGalleryFromDescription()">
        <app-hotel-detail-reservation-data reservation
          [hotel]="hotelDetail$ | async"
          [params]="params"
          [isPackageHotel]="isPackageDetail$ | async"
          [isByhours]="isByhours$ | async"
          [hourType]="hourType$ | async"
          (showHotelSearchSwipe)="toggleSearchPanel()">
        </app-hotel-detail-reservation-data>
      </app-hotel-description-mobile>
    </div>

    <div class="hotelDetailMobile__selectRoomButton">
      <app-fixed-surface
        [boxShadow]="true"
        [surface]="surface">
        <div class="hotelDetailMobile__selectRoomButton__cont">
          <app-night-price-resume
            [labelNightsNumber]="labelNumber$ | async"
            [totalPrice]="(hotelDetail$ | async)?.Result.RoomRates[0].Price?.Total"
            [currencyCode]="(hotelDetail$ | async)?.Result.RoomRates[0].Price?.CurrencyCode">
          </app-night-price-resume>
          <app-ds-button
            [labels]="{ ButtonLabel: 'HOTELS_MODULE.RESULT_HOTELS.SELECT_ROOM' | transloco }"
            (clickEvent)="showRooms()">
          </app-ds-button>
        </div>
      </app-fixed-surface>
    </div>

    <div class="modal" [ngClass]="{'open': showMap}">
      <div class="cont-map">
        <div class="icon-close" (click)="toggleMap()"></div>
        <app-map [markers]="hotelMarkers$ | async"></app-map>
      </div>
      <div class="mask" (click)="toggleMap()"></div>
    </div>
    <div class="edit-bar-in-detail">
      <app-swipe-up
        [height]="63"
        [showSwipeUp]="showPanel"
        [classType]="'search'"
        (toggleShowSwipeUp)="toggleSearchPanel()">
        <ng-container content>
          <div class="content" [class.byhours]="isByhours$ | async">
            <ng-container *ngIf="isPackageDetail$ | async; else hotelSearchBar">
              <app-packages-search-bar
                [showHotelDetail]="true"
                [searchType]="searchType"
                [source]="source"
                [hotelDetail]="hotelDetail$ | async"
                (showMobileCalendarEvent)="showMobileCalendar($event)">
              </app-packages-search-bar>
            </ng-container>
            <ng-template #hotelSearchBar>
              <ng-container *ngIf="(isByhours$ | async); else isHotelSearch">
                <app-byhours-search
                  [showHotelDetail]="true"
                  [hotelDetail]="hotelDetail$ | async"
                  [showSearch]="showPanel"
                  [searchType]="searchType"
                  [source]="source"
                  [isMobile]="true"
                  (showMobileCalendarEvent)="showMobileCalendar($event)"
                  (redirectToSearch)="redirectToSearchHotelDetail()">
                </app-byhours-search>
              </ng-container>
              <ng-template #isHotelSearch>
                <app-hotel-search
                  [showHotelDetail]="true"
                  [hotelDetail]="hotelDetail$ | async"
                  [showSearch]="showPanel"
                  [searchType]="searchType"
                  [source]="source"
                  [isMobile]="true"
                  (showMobileCalendarEvent)="showMobileCalendar($event)"
                  (redirectToSearch)="redirectToSearchHotelDetail()">
                </app-hotel-search>
              </ng-template>
            </ng-template>
          </div>
        </ng-container>
      </app-swipe-up>
    </div>
  </ng-container>
</div>

<ng-template #detailPlaceholder>
  <ng-container *ngIf="(hotelDetailSearched$ | async); else travelLoader">
    <div class="hotel-detail-placeholder">
      <div class="info">
        <div class="passengers-data"></div>
        <div class="main-room">
          <div class="title"></div>
          <div class="place"></div>
          <div class="price"></div>
          <div class="button"></div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #travelLoader>
    <app-travel-loader [classType]="loaderClassType"></app-travel-loader>
  </ng-template>
</ng-template>

<app-swipe-up
  [height]="95"
  [showSwipeUp]="showRoomsSwipe"
  [title]="'HOTELS_MODULE.DETAIL_DESCRIPTION.SELECT_ROOM'| transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toogleShowRooms()">
  <ng-container content *ngIf="showRoomsSwipe">
    <app-hotel-rooms-mobile
      [hasRappiCard]="hasRappiCard"
      [isPrime]="isPrime"
      [isLoggedIn]="isLoggedIn"
      [isByhours]="isByhours$ | async"
      [classTag]="(hotelDetail$ | async)?.Result?.ClassTag">
    </app-hotel-rooms-mobile>
  </ng-container>
</app-swipe-up>

<ng-container *ngIf="showCalendar">
  <router-outlet name="search"></router-outlet>
</ng-container>
<ng-container *ngIf="showHotelDetail">
  <router-outlet name="hotel-detail" (deactivate)='deactivateRooms()'></router-outlet>
</ng-container>
